const LocalStorageKeys = {
  ActiveDraftId: 'activeDraft'
};

export default LocalStorageKeys;
